// src/pages/ledger/LedgerSkeleton.jsx
import React from "react";

const SkeletonFilterCard = () => (
  <div className="card">
    <div className="skeleton skeleton-title" />
    <div className="skeleton skeleton-input" style={{ height: 42, marginBottom: 14 }} />
    <div className="grid">
      <div className="skeleton-field">
        <div className="skeleton skeleton-label" />
        <div className="skeleton skeleton-input" />
      </div>
      <div className="skeleton-field">
        <div className="skeleton skeleton-label" />
        <div className="skeleton skeleton-input" />
      </div>
      <div className="skeleton-field field-full">
        <div className="skeleton skeleton-label" />
        <div className="skeleton skeleton-input" />
      </div>
    </div>
  </div>
);

const SkeletonTableRow = () => (
  <tr>
    {[1, 2, 3, 4, 5, 6, 7].map((i) => (
      <td key={i}>
        <div className="skeleton skeleton-cell" />
      </td>
    ))}
  </tr>
);

const SkeletonTableCard = () => (
  <div className="card">
    <div className="card-header-row">
      <div className="skeleton skeleton-title" style={{ width: 160, margin: 0 }} />
      <div className="skeleton skeleton-btn-sm" />
    </div>

    <div className="overflow">
      <table>
        <thead>
          <tr>
            {["تاریخ", "نوع", "شماره", "شرح", "بدهکار", "بستانکار", "مانده"].map(
              (h) => (
                <th key={h}>{h}</th>
              )
            )}
          </tr>
        </thead>
        <tbody>
          {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
            <SkeletonTableRow key={i} />
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

export default function LedgerSkeleton({ withTable = false }) {
  return (
    <>
      <SkeletonFilterCard />
      {withTable && <SkeletonTableCard />}

      <style>{`
        .skeleton {
          background: linear-gradient(
            90deg,
            var(--border) 25%,
            var(--border-strong) 50%,
            var(--border) 75%
          );
          background-size: 200% 100%;
          animation: skeleton-shimmer 1.4s ease-in-out infinite;
          border-radius: 8px;
        }
        @keyframes skeleton-shimmer {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
        .skeleton-title {
          height: 22px;
          width: 40%;
          margin-bottom: 20px;
        }
        .skeleton-field {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }
        .skeleton-label {
          height: 13px;
          width: 40%;
        }
        .skeleton-input {
          height: 42px;
          width: 100%;
          border-radius: 10px;
        }
        .skeleton-btn-sm {
          height: 36px;
          width: 100px;
          border-radius: 10px;
        }
        .skeleton-cell {
          height: 16px;
          width: 80%;
          margin: 0 auto;
        }
      `}</style>
    </>
  );
}